import React, { useState, lazy, Suspense } from "react";
const EventSignupModal = lazy(() => import("./modals/EventSignupModal"));
import { ALL_EVENTS } from "@/data/events";

export default function HeroSection() {
  const [signupOpen, setSignupOpen] = useState(false);
  const bgImage = "/hero-bg.jpg";

  return (
    <>
      <section
        className="
          relative isolate min-h-screen w-full flex items-center pt-24
          bg-[#0f2336] 
        "
      >
        <div aria-hidden className="absolute inset-0 z-10 bg-[#0f2336]/70 h-[100%]" />

        <div
          aria-hidden
          className="
            pointer-events-none
            absolute left-0 right-0 bottom-0
            -z-10 bg-center bg-cover
            transform-gpu scale-105
          "
          style={{ top: '6rem' }}
        >
          <img
            src={bgImage}
            alt=""
            className="
              w-full h-full object-cover
              blur-sm
            "
            decoding="async"
            width={2400}
            height={1350}
            sizes="100vw"
          />

        </div>

        <div className="relative z-20 container mx-auto px-5 sm:px-8 pt-24 pb-16">
          <div className="max-w-4xl">
            <h1
              className="
                font-montserrat font-extrabold text-white
                text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight text-shadow
                [text-wrap:balance] uppercase`
              "
            >
              ZeroClub — International business community 
            </h1>

            <p className="text-white/90 font-montserrat text-base sm:text-lg md:text-xl mt-6 max-w-xl text-shadow-sm">
              Place where connections turn into opportunities and knowledge into transformation
            </p>

            <div className="mt-8 grid gap-3 sm:flex sm:items-center">
              <button
                onClick={() => setSignupOpen(true)}
                className="
                  group relative
                  w-full sm:w-auto inline-flex justify-center items-center
                  h-12 px-6 rounded-md
                  bg-accent-orange text-white font-semibold text-sm md:text-base
                  transition-[background,box-shadow,transform] duration-300 ease-out
                  hover:bg-orange-500
                  hover:shadow-lg hover:shadow-orange-500/25
                  active:scale-[0.98]
                  overflow-hidden
                  transform-gpu
                "
              >
                <span className="relative z-10 flex items-center gap-2 font-montserrat">
                  Join Our Community
                </span>
                <span
                  className="
                    absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent 
                    -translate-x-full group-hover:translate-x-full 
                    transition-transform duration-700 ease-out
                    motion-reduce:transition-none 
                    pointer-events-none
                  "
                />
              </button>

              <a
                href="#events"
                className="
                  group relative
                  w-full sm:w-auto inline-flex justify-center items-center
                  h-12 px-6 rounded-md
                  font-semibold text-white/90
                  border border-white/20 bg-white/5
                  transition-[background,border-color,box-shadow,transform] duration-300 ease-out
                  hover:bg-white/10 hover:border-white/40 hover:text-white
                  hover:shadow-lg hover:shadow-white/5
                  active:scale-[0.98]
                  transform-gpu
                "
              >
                <span className="relative z-10 font-montserrat">View Events</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {signupOpen && (
        <Suspense fallback={null}>
          <EventSignupModal
            open={signupOpen}
            onClose={() => setSignupOpen(false)}
            events={ALL_EVENTS}
            defaultEventId={undefined}
          />
        </Suspense>
      )}
    </>
  );
}
